module.exports = __webpack_public_path__ + "static/media/loader.73e35629.gif";